<script>
export default {
  props: {
    disabled: {
      type: [Boolean, String],
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    errors: {
      type: [Object, String],
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      error: false
    }
  },
  computed: {
    classObject: function () {
      return {
        'has-error': this.error
      }
    }
  },
  watch: {
    errors: function (newValue) {
      if (newValue && newValue[this.name]) {
        this.errorText = Object.values(newValue[this.name]).join()
        this.error = true
      } else {
        this.errorText = false
        this.error = false
      }
    }
  },
}
</script>
